// An open incident counts as overdue (shown in red) once it has waited this long
export const INCIDENT_OVERDUE_AFTER_MS = 3 * 60_000;

/** "4m 07s" below an hour, "1h 05m" after that. */
export const formatElapsed = (milliseconds: number) => {
    const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (value: number) => String(value).padStart(2, "0");
    return hours > 0 ? `${hours}h ${pad(minutes)}m` : `${minutes}m ${pad(seconds)}s`;
};
